<template>
    <!-- <div class="Questionbank bgc box-shadow padding-20"> -->
    <div class="Questionbank bgc box-shadow">
        <div class="handle_btn_box">
            <div class="left_div">
                <el-button @click="toPage('QuestionbankMsg')" type="primary">添加题目</el-button>
                <el-button @click="toPage('QuestionbankType')" type="primary">试题分类</el-button>
                <!-- <el-button @click="openBulkImportPop()" type="primary" plain>批量录入</el-button> -->
                <el-button @click="openBulkImportPop()" type="primary" plain>EXCEL导入</el-button>
            </div>
            <div class="right_div">
                <el-select style="width: 108px;" v-model="topicValue" placeholder="全部题型">
                    <el-option v-for="item in topicOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input style="margin:0 20px; width: 220px;" v-model="keywordsValue" placeholder="请输入题目名称关键词"></el-input>
                <el-button @click="handleQuery()" type="primary" plain>搜索</el-button>
            </div>
        </div>
        <div class="content_warp">
            <div class="content_left_box">
                <div class="tree_warp_box">
                    <el-tree :data="classInfoData" node-key="id" :default-expanded-keys="[1, 2]" @node-click="handleNodeClick" :expand-on-click-node="false">
                        <span class="custom-tree-node" slot-scope="{node, data}">
                            <span style="margin-right: 12px;">{{node.label}}</span>
                            <span style="color: #909399;">{{data.datacount}}</span>
                        </span>
                    </el-tree>
                </div>
            </div>
            <div class="content_right_box">
                <div v-if="multipleSelection.length > 0" class="select_handle_box">
                    <p>已选择<span> {{multipleSelection.length}} </span>项</p>
                    <span @click="openTransferPop(true)" class="handle_span">转移</span>
                    <span class="line_span">丨</span>
                    <span @click="openCopyPop(true)" class="handle_span">复制</span>
                    <span class="line_span">丨</span>
                    <span @click="delQuestionsClick(2)" class="handle_span">删除</span>
                </div>
                <div class="questions_table_box" :class="multipleSelection.length > 0 ? 'is_select_data' : ''">
                    <el-table ref="multipleTable" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="42"></el-table-column>
                        <el-table-column label="题目" min-width="220" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div v-html="scope.row.subject" class="text-ellipse"></div>
                                <!-- {{scope.row.subject}} -->
                            </template>
                        </el-table-column>
                        <el-table-column prop="questiontypename" label="题型" min-width="80" align="center"></el-table-column>
                        <el-table-column prop="defaultscore" label="默认分数" min-width="60" align="center"></el-table-column>
                        <!-- <el-table-column prop="defaultscore" label="默认分数" width="100" align="center"></el-table-column> -->
                        <el-table-column prop="datetime" label="最后更新时间" width="160" align="center"></el-table-column>
                        <el-table-column label="操作" align="right" width="240">
                            <template slot-scope="scope">
                                <div class="table_row_handle_box">
                                    <span class="handle_span" @click="toPageInnerid('QuestionbankMsg', scope.row.innerid)">编辑</span>
                                    <span class="line_span">丨</span>
                                    <span @click="openTransferPop(false, scope.row)" class="handle_span">转移</span>
                                    <span class="line_span">丨</span>
                                    <span @click="openCopyPop(false, scope.row)" class="handle_span">复制</span>
                                    <span class="line_span">丨</span>
                                    <!-- <span @click="openNoClassPop()" class="handle_span">删除</span> -->
                                    <span @click="delQuestionsClick(1, scope.row)" class="handle_span">删除</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <page :total="totalPage" ref="page" @getList="findAllQuestionInfo"></page>
            </div>
        </div>
        <BulkImportPop @getQuesInfo="getQuesInfo" @openSelectClassPop="openSelectClassPop" ref="bulkimportpop"></BulkImportPop>
        <TransferPop @getClassId="getClassId" ref="transferpop"></TransferPop>
        <CopyPop @getClassId="getClassId" ref="copypop"></CopyPop>
        <NoClassPop ref="noclasspop"></NoClassPop>
        <SelectClassPop @getClassInfo="getClassInfo" ref="selectclasspop"></SelectClassPop>
    </div>
</template>

<script>
import {getAllHostcatalog, getAllQuestionInfo, deleteQuestion, copyQuestion, moveQuestionToCate} from 'api/questionApi'
import Page from 'base/page/page4'
import BulkImportPop from 'views/questionbank/components/BulkImportPop'
import TransferPop from 'views/questionbank/components/TransferPop'
import CopyPop from 'views/questionbank/components/CopyPop'
import SelectClassPop from 'views/questionbank/components/SelectClassPop'
import NoClassPop from 'views/questionbank/components/NoClassPop'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'Questionbank',
    data() {
        return {
            classId: '',
            keywordsValue: '',
            topicValue: '',
            topicOptions: [
                {
                    value: '',
                    label: '全部题型'
                },
                {
                    value: 1,
                    label: '单选题'
                },
                {
                    value: 2,
                    label: '多选题'
                },
                {
                    value: 3,
                    label: '不定项选择题'
                },
                {
                    value: 4,
                    label: '判断题'
                },
                {
                    value: 5,
                    label: '填空题'
                },
                {
                    value: 6,
                    label: '问答题'
                }
            ],
            totalPage: 0,
            tableData: [],
            multipleSelection: [],
            classInfoData: [],
            defaultProps: {children: 'children', label: 'label'},
            selectIds: ''
        }
    },
    mounted() {
        this.findAllHostcatalog()
        this.findAllQuestionInfo()
    },
    methods: {
        // 导入excel获取选择的分类信息
        getClassInfo(id, classname) {
            this.$refs.bulkimportpop.setClassName(classname, id)
        },
        // 获取分类菜单id
        getClassId(id, type) {
            // this.$refs.copypop.closeDialog()
            if(type === '复制题目') {
                this.copyQuestionFn(id)
            } else if(type === '转移题目') {
                this.moveQuestionToCateFn(id)
            }
        },
        // 复制题目
        copyQuestionFn(classid) {
            this.setLoading(true)
            var params = {
                innerids: this.selectIds,
                cateid: classid
            }
            copyQuestion({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.$refs.copypop.closeDialog()
                    this.findAllHostcatalog()
                    this.findAllQuestionInfo()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 转移题目
        moveQuestionToCateFn(classid) {
            this.setLoading(true)
            var params = {
                innerids: this.selectIds,
                cateid: classid
            }
            moveQuestionToCate({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.$refs.copypop.closeDialog()
                    this.findAllHostcatalog()
                    this.findAllQuestionInfo()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 分类点击
        handleNodeClick(data) {
            // console.log(data)
            this.totalPage = 0
            this.classId = data.id
            if(data.id === 1) {
                this.classId = ''
            }
            // this.keywordsValue = ''
            // this.topicValue = ''
            this.handleQuery()
        },
        // 获取题库分类列表，按elementui树结构返回，代码需支持无限级，使用递归算法
        findAllHostcatalog() {
            this.setLoading(true)
            var params = {
                catetype: 1,
                showdefault: 1
            }
            getAllHostcatalog({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // this.classInfoData = [
                    //     {label: data.data.label, id: data.data.id, datacount: data.data.datacount, children: data.data.content}
                    // ]
                    this.classInfoData = [data.data]
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        // 获取题库试题信息列表，只获取状态正常的数据
        findAllQuestionInfo() {
            this.setLoading(true)
            var params = {
                subject: this.keywordsValue, // 题目关键词
                questiontype: this.topicValue, // 试题类型：0或者空 全部 1单选题 2多选题 3不定项选择题 4判断题 5填空题 6问答题
                cateid: this.classId, // 分类id，可为空
                page: this.$refs.page ? this.$refs.page.pagination.page : 1,
                pagesize: this.$refs.page ? this.$refs.page.pagination.pageSize : 10,
            }
            getAllQuestionInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.totalPage = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        // 删除试题   type :   1、删除单个试题  2、批量删除试题
        delQuestionsClick(type, val) {
            this.$confirm('是否确认删除该题目？', '删除题目', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var params = {
                    innerids: '',
                }
                if(type === 1) {
                    // 删除单个试题
                    // console.log(val)
                    params.innerids = val.innerid
                } else {
                    // 批量删除试题
                    // console.log(this.multipleSelection)
                    var delIds = []
                    for (let i = 0; i < this.multipleSelection.length; i++) {
                        delIds.push(this.multipleSelection[i].innerid)
                    }
                    delIds = delIds.join(',')
                    params.innerids = delIds
                }
                // console.log(params)
                this.setLoading(true)
                deleteQuestion({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.$message.success('删除成功！')
                        var page = {}
                        if(type === 1) {
                           if(this.tableData.length === 1 && this.$refs.page.pagination.page > 1) {
                                // page = {page: this.page.page - 1, pageSize: 10}
                                // if(page.page === 0) {
                                //     page.page = 1
                                // }
                                // this.setPage(page)
                                // this.handleQuery()
                                this.$refs.page.pagination.page--
                            }
                        } else {
                            if(this.multipleSelection.length === this.tableData.length && this.$refs.page.pagination.page > 1) {
                                // page = {page: this.page.page - 1, pageSize: 10}
                                // if(page.page === 0) {
                                //     page.page = 1
                                // }
                                // this.setPage(page)
                                this.$refs.page.pagination.page--
                            }
                        }
                        this.findAllQuestionInfo()
                        this.findAllHostcatalog()
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {
                // 取消
            })
        },
        // 打开批量导入弹窗
        openBulkImportPop() {
            this.$refs.bulkimportpop.openDialog()
        },
        // 导入EXCEL 成功 重新调取接口
        getQuesInfo() {
            this.findAllHostcatalog()
            this.findAllQuestionInfo()
        },
        // 打开转移题目弹窗
        openTransferPop(batch, item) {
            // this.$refs.transferpop.openDialog(this.classInfoData)
            if(this.classInfoData[0].children.length > 1) {
                if(batch) {
                    var ids = []
                    for (let i = 0; i < this.multipleSelection.length; i++) {
                        ids.push(this.multipleSelection[i].innerid)
                    }
                    ids = ids.join(',')
                    this.selectIds = ids
                    // console.log(this.multipleSelection)
                    // console.log(this.selectIds)
                } else {
                    this.selectIds = item.innerid
                    // console.log(item)
                    // console.log(this.selectIds)
                }
                this.$refs.copypop.openDialog(this.classInfoData, '转移题目')
            } else {
                this.openNoClassPop()
            }
        },
        // 打开复制题目弹窗
        openCopyPop(batch, item) {
            if(this.classInfoData[0].children.length > 1) {
                if(batch) {
                    var ids = []
                    for (let i = 0; i < this.multipleSelection.length; i++) {
                        ids.push(this.multipleSelection[i].innerid)
                    }
                    ids = ids.join(',')
                    this.selectIds = ids
                    // console.log(this.multipleSelection)
                    // console.log(this.selectIds)
                } else {
                    this.selectIds = item.innerid
                    // console.log(item)
                    // console.log(this.selectIds)
                }
                this.$refs.copypop.openDialog(this.classInfoData, '复制题目')
            } else {
                this.openNoClassPop()
            }
        },
        // 打开无分类时弹窗
        openNoClassPop() {
            this.$refs.noclasspop.openDialog(this.classInfoData)
        },
        // Eexcl导入选择分类弹窗
        openSelectClassPop() {
            this.$refs.selectclasspop.openDialog(this.classInfoData)
        },
        // 页面跳转
        toPage(pageName) {
            this.$router.push({name: pageName})
        },
        // 带路由页面跳转
        toPageInnerid(pageName, innerid) {
            this.$router.push({name: pageName, query: {innerid: innerid}})
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page,
        BulkImportPop,
        TransferPop,
        CopyPop,
        NoClassPop,
        SelectClassPop
    }
}
</script>

<style lang="scss" type="text/scss" scope>
.Questionbank {
    // min-height: 90vh;
    display: flex;
    flex-direction: column;
    .handle_btn_box {
        display: flex;
        justify-content: space-between;
        padding: 20px;
        padding-bottom: 30px;
        .left_div {
            .el-button+.el-button {
                margin-left: 20px;
            }
        }
        .right_div {
            display: flex;
            .el-input__icon {
                line-height: 0;
            }
        }
    }
    .content_warp {
        // flex: 1;
        display: flex;
        min-height: calc(100vh - 172px);
        .content_left_box {
            width: 300px;
            min-width: 300px;
            flex: 0 0 auto;
            margin-right: 30px;
            // padding-bottom: 34px;
            .tree_warp_box {
                overflow: auto;
                height: calc(100vh - 172px);
                box-sizing: border-box;
                border-top: 1px solid #e5e5e5;
                border-right: 1px solid #e5e5e5;
                // border-left: none;
                .el-tree-node__content {
                    height: 40px;
                }
                .el-tree .el-tree-node.is-current > .el-tree-node__content {
                    background-color: #FAFAFA;
                    color: #409EFF;
                }
            }
            .tree_warp_box::-webkit-scrollbar {
                width: 6px;
            }
            .tree_warp_box::-webkit-scrollbar-thumb {
                border-radius: 4px;
                background:rgba(229,229,229,1);
            }
            .tree_warp_box::-webkit-scrollbar-track {
                border-radius: 4px;
                background: #fff;
            }
        }
        .content_right_box {
            padding-bottom: 20px;
            padding-right: 20px;
            width: 100%;
            height: calc(100vh - 202px);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .select_handle_box {
                display: flex;
                align-items: center;
                height: 35px;
                background-color: #E6F1FC;
                border:1px solid rgba(64,158,255,1);
                box-sizing: border-box;
                margin-bottom: 20px;
                &>p {
                    padding-left: 15px;
                    padding-right: 30px;
                    color: #909399;
                }
                span {
                    color: #409EFFFF;
                }
                .handle_span {
                    cursor: pointer;
                }
                .handle_span:hover {
                    color: rgb(13, 127, 241);
                }
                .line_span {
                    margin: 0 6px;
                }
            }
            .is_select_data{
                max-height: calc(100vh - 310px)!important;
            }
            .questions_table_box {
                /*max-height: calc(100vh - 250px);*/
                overflow: auto;
                .el-table th>.cell {
                    font-weight: bold!important;
                    // white-space: nowrap;
                    // font-size: 16px;
                }
                .el-table td {
                    padding: 20px 0;
                }
                .el-table__empty-text {
                    box-sizing: border-box;
                    line-height: 140px;
                    padding-top: 180px;
                }
                .table_row_handle_box {
                    span {
                        color: #409EFFFF;
                        font-size: 12px;
                    }
                    .handle_span {
                        cursor: pointer;
                    }
                    .handle_span:hover {
                        color: rgb(13, 127, 241);
                    }
                    .line_span {
                        margin: 0 6px;
                    }
                }
            }
            .questions_table_box::-webkit-scrollbar {
                width: 6px;
            }
            .questions_table_box::-webkit-scrollbar-thumb {
                border-radius: 4px;
                background:rgba(229,229,229,1);
            }
            .questions_table_box::-webkit-scrollbar-track {
                border-radius: 4px;
                background: #fff;
            }
        }
    }
}


.el-dialog__wrapper {
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*text-align: left;*/
}
.el-dialog {
    /*margin: 0!important;*/
}
.el-dialog .el-dialog__body {
    padding: 6px;
    // padding-right: 6px;
}
.dialog-footer {
    .el-button+.el-button {
        margin-left: 20px;
    }
}
</style>
<style lang="scss" type="text/scss" scope>
    .el-tooltip__popper {
        color: #303133!important;
    }
</style>
